<template>
  <div ref="layout" class="page-query">
    <TableQuery title="" :show-button="false">
      <template #queryButton>
        <el-button type="default" size="medium" @click="saveData"><img src="@/assets/images/rest@3x.png">保存</el-button>
      </template>
      <el-form  ref="form" :model="conditions"
                                   :rules="rules"
                                    inline size="mini" label-width="100px" label-position="left">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="销售内勤">
               <el-input v-model="conditions.staffNo" @focus="openDialog($event, '销售内勤人员选择')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <!-- 战区选择 -->
    <el-row :gutter="24">
      <transfer
        key="war"
        left-header="营销单元列表"
        :data-srouce="saleCenterGridOptions"
        :data-srouce-columns="dataSrouceColumnsSaleCenter"
        :right-data-srouce="selectedSaleCenter"
        transfer-type="war"
        right-header="已选营销单元列表"
        @syncTransferSelectedData="syncTransferSelectedData"
      />
    </el-row>

   <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
      destroy-on-close
    >


        <staff-select ref="dialogSelect" />

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 <!-- 选择通用弹窗情况 -->

<script>

import { findWlyOrg } from '@/api/client'
import Transfer from './components/Transfer.vue'
import StaffSelect from '@/components/dialog/StaffSelect.vue'
import { assginSaleCenter,loadChargeSaleCenter } from '@/api/applyForGoods/staff'
export default {
  components: {
    Transfer,StaffSelect
  },

  data() {
    return {
    rules: {staffNo: [{ required: true, message: '请选择内勤人员', trigger: 'change' }]},
    loading: false,
      tableData: [],
      dialogTitle: '',
      selectedSaleCenter: [],
      conditions: {
        id: '',
        staffNo: '',
        staff: '',
        chargeSalecenters: [],


      },
      saleCenterGridOptions: [],
      showDialog: false,
      dataSrouceColumnsSaleCenter: [
        {
          name: '战区',
          code: 'deptName'
        },
        {
          name: '编码',
          code: 'deptCode'
        }
      ]
    }
  },
  created() {

    // 组织机构查询
    this.findWlyOrg()

  },
  methods: {
    saveData() {
      this.$emit('close', this.conditions)
      const params = JSON.parse(JSON.stringify(this.conditions))
            const _this = this
            _this.$refs['form'].validate(valid => {
              if (valid) {

                    _this.loading = true
                    assginSaleCenter(params)
                      .then(response => {
                        _this.loading = false
                         Object.assign(_this.conditions, response.data)
                        _this.$message.success('保存成功')
                      })
                      .catch(() => {
                        _this.loading = false
                      })


              }
            })
    },
    syncTransferSelectedData(data, type) {
      console.log('-syncTransferSelectedData===========', data, type)

      this.conditions.chargeSalecenters = data


    },
    openDialog(e, title) {
      console.log("here")
      e.target.blur()
      this.dialogTitle = title
      this.showDialog = true
    },
     async submitHandle() {
          const data = await this.$refs.dialogSelect.submitForm()
          if (data) {
              this.confirmEmployeer(data)
          }
        },
    // 确认人员选择
       async confirmEmployeer(data) {

         this.conditions.staffNo = data.code
         this.conditions.staff = data.name
         this.showDialog = false
          //加载已选择的战区
         this.loadSaleCenter(this.conditions)
        },
    // 获取组织机构
    async findWlyOrg() {
      const { data } = await findWlyOrg()
       console.log("data:",data)
      this.saleCenterGridOptions = data
      console.log(data)
    },
    async loadSaleCenter(person) {
      const { data } = await loadChargeSaleCenter(person)
      this.selectedSaleCenter = data
    },
    handleCancel() {
      this.$emit('close', this.conditions)
    }
  }
}
</script>
<style scoped lang="scss">
    .remark-item{
        margin-top:20px;
    }
    .district-block{
        padding: 0 60px;
    }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/StaffSaleCenterSetting.vue